"use strict";

window.addEventListener('load', () => {
      const catchItm = document.querySelectorAll('.f-hero-ph__catch-itm');
      let delay = 1;
      catchItm.forEach(itm => {
            setTimeout(() => {
                  itm.classList.add('is-active');
            }, delay * 1000);

            delay += 1.2;
      });
});
